module.exports = __webpack_public_path__ + "media/images/badge-order-active-923d6f923b348583e58acdafba1e7ba7.svg";